/**
 * siteManagementApi.js
 * API helpers for the Site Management page.
 */

import { apiFetch } from '../../auth/apiFetch';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071/api';

export async function getSites(callerEmail) {
  const params = new URLSearchParams({ caller_email: callerEmail });
  const res = await apiFetch(`${API_BASE_URL}/get_sites?${params}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json();
}

export async function createSite(callerEmail, fields) {
  const params = new URLSearchParams({ caller_email: callerEmail });
  const res = await apiFetch(`${API_BASE_URL}/manage_site?${params}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(fields),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json();
}

export async function updateSite(callerEmail, siteId, fields) {
  const params = new URLSearchParams({ caller_email: callerEmail, site_id: siteId });
  const res = await apiFetch(`${API_BASE_URL}/manage_site?${params}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(fields),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json();
}
